import api from './api';

const REFERENCE_ENDPOINT = '/accounting-invoice-references';

const getSourceType = row => row?.source_type || row?.payment_type;
const getSourceId = row => row?.source_id ?? row?.payment_id ?? row?.reservation_id ?? row?.commission_id ?? row?.id;

export async function loadAccountingInvoiceReferences(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return [];

  const items = rows.map(row => ({
    source_type: getSourceType(row),
    source_id: String(getSourceId(row))
  }));
  const result = await api.post(`${REFERENCE_ENDPOINT}/lookup`, { items });
  const referenceMap = new Map((result.references || []).map(reference => [
    `${reference.source_type}:${reference.source_id}`,
    reference.invoice_reference
  ]));

  return rows.map(row => {
    const key = `${getSourceType(row)}:${String(getSourceId(row))}`;
    return { ...row, invoice_reference: referenceMap.get(key) || null };
  });
}

export async function getAccountingInvoicePeriod(year, month) {
  const result = await api.get(`${REFERENCE_ENDPOINT}/${year}/${month}/status`);
  return result.period;
}

export async function issueAccountingInvoices(year, month) {
  return api.post(`${REFERENCE_ENDPOINT}/${year}/${month}/issue`, {});
}

export async function reopenAccountingInvoicePeriod(year, month) {
  const result = await api.post(`${REFERENCE_ENDPOINT}/${year}/${month}/reopen`, {});
  return result.period;
}
